<div id="contact">
  <div mat-dialog-content>
    <h4>You'll be redirected to another page to get</h4>
    <h4>detailed travel info. click "Continue" to proceed.</h4>
  </div>
  <div mat-dialog-actions style="display: flex; gap: .5rem;">
    <a
      style="outline: none;"
      target="_blank"
      href="https://www.heirsgeneralinsurance.com/travel-business"
    >
      <button style="color: #fff;" mat-raised-button mat-dialog>Continue</button>
    </a>
    <button style="border: 1px solid red; color: red;" mat-button mat-dialog-close>Close</button>
  </div>
</div>
 